import { ReviewItem } from '~/data/product/interfaces';
import Carousel from '../Carousel';
import Icon from '../Icon';
import ModalContainer from '../Modals/ModalContainer';
import styles from './ImagesReviewCarousel.module.scss';
import SliderItemReview from './SliderItemReview';

const getReviewItemByImgUrl = (items: ReviewItem[], url: string) => {
    if (!items) return {};
    return items.find((item) => item?.images?.includes(url));
};
type Props = {
    onClose: () => void;
    open: boolean;
    initialSlide: number;
    images: string[];
    items: ReviewItem[];
};

const ModalCarousel = ({ onClose, open, initialSlide, images, items }: Props) => {
    return (
        <ModalContainer
            open={open}
            onClose={onClose}
            type="bottom-sheet"
            className="h-[85vh] !max-w-[813px]"
            wrapperClassName="absolute left-0 top-0 w-full h-full overflow-visible"
        >
            <Carousel
                infinite={false}
                speed={500}
                slidesToShow={1}
                touchThreshold={100}
                className={styles.modal_images_review_slider}
                initialSlide={initialSlide}
                responsive={[
                    {
                        breakpoint: 768,
                        settings: {
                            arrows: false
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            arrows: false
                        }
                    }
                ]}
            >
                {images.map((url, index) => {
                    return (
                        <SliderItemReview
                            key={index}
                            data={getReviewItemByImgUrl(items, url) as ReviewItem}
                            url={url}
                        />
                    );
                })}
            </Carousel>
            <div
                className={`absolute top-1 right-2 z-10 hover:bg-[#00000085] bg-[#00000050] h-8 w-8 
          rounded-full transition-all cursor-pointer`}
                onClick={() => onClose()}
            >
                <Icon name="close" size={32} className="text-gray-50 hover:text-gray-300 transition-all ms-[0.5px]" />
            </div>
        </ModalContainer>
    );
};

export default ModalCarousel;
